import {
  TABLE_COLUMNS_CHANGED,
  TABLE_COLUMN_MOVED,
} from '@xmatters/redux/actions/table';

export default function table(state = {}, action) {
  const { type, payload } = action;
  switch (type) {
    case TABLE_COLUMNS_CHANGED:
    case TABLE_COLUMN_MOVED: {
      return {
        ...state,
        [payload.tableName]: {
          columns: payload.columns,
        },
      };
    }
    default:
      return state;
  }
}
